import React, {useState, useRef, useEffect} from "react";
import CookieButton from "./CookieButton";
import useOutsideAlerter from "functions/useOutsideAlerter";
import clg from "functions/log";

/*
    settingName > cookieban eltárolt név

*/

const SettingItem = ({title, description, disabled = false, checked = false, onChange = null, settingName = null, nonModifiableValue = null}) => {

    const [checkedState, setCheckedState] = useState(checked);

    useEffect(() => {
        if( onChange && typeof onChange === "function" ) { 
            onChange({
                settingName : settingName,
                checked : ( nonModifiableValue ? nonModifiableValue : checkedState), //Ha nem módosítható érték van megadva, akkor ez az érték kerül a cookie_settings cookieba.
            });
        }
    },[checkedState])

    return(
        <div className="setting-item">
            <div className="up">
                <div className="title">{title}</div>
                <input type="checkbox" className="toggle" checked={checkedState} disabled={disabled} onChange={ (e) => setCheckedState(e.target.checked) }/>
            </div>
            <div className="description">{description}</div>
        </div>
    )
}

const CookieSettings = ({setOpen = null, items = [], acceptSelected = null}) => {

    const settingsRef = useRef(null);
    
    const createSelectedDefault = () => {
        let _default = {};
        items.map((curr,index) => {
            _default[ curr.settingName ] = ( curr.nonModifiableValue ? curr.nonModifiableValue : curr.checked );
        });

        return _default;
    }

    const [selected, setSelected] = useState(createSelectedDefault());

    const handleSettingChange = ( setting ) => {
        //clg("SET ", setting);
        setSelected({
            ...selected,
            [setting.settingName] : setting.checked
        });
    }

    const close = () => {
        if( setOpen && typeof setOpen === "function" ) {
            setOpen(false);
        }
    }

    useOutsideAlerter(settingsRef, close);

    return(
        <div className="cookie-settings">
            <div className="inner" ref={settingsRef}>
                <div className="head">
                    <span>Sütibeállítások testreszabása</span>
                    <i className="fas fa-times" onClick={ () => close()}></i>
                </div>
                <div className="body">
                    {
                        items.map((curr,index) => {
                            if( !curr.hasOwnProperty("hidden") ) {
                                return(
                                    <SettingItem
                                        title={curr.title}
                                        description={curr.description}
                                        disabled={ ( curr.hasOwnProperty("disabled") ? curr.disabled : false ) }
                                        checked={ ( curr.hasOwnProperty("checked") ? curr.checked : false ) }
                                        onChange={ (setting) => handleSettingChange(setting) }
                                        settingName={ curr.settingName }
                                        nonModifiableValue={ curr.hasOwnProperty("nonModifiableValue") ? curr.nonModifiableValue : null }
                                        key={index}
                                    />
                                )
                            }
                        })
                    }
                </div>
                <div className="foot row">
                    <div className="col-6">
                        <CookieButton text="Bezárás" className="secondary small" icon="fas fa-times" onClick={ () => close()}/>
                    </div>
                    <div className="col-6">
                        <CookieButton text="Beállítások mentése" className="primary small" icon="fas fa-check" onClick={ () => {
                            if( acceptSelected && typeof acceptSelected === "function" ) {
                                acceptSelected(selected)
                                window.location.reload();
                            }
                        } }/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CookieSettings;